/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 * Styled components for MultiSelect
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Ilya Babanov
 * @author Andrey Dubov
 * @author Alexander Golshtein
 * @version 1.24.0
 * @since 1.0.0
 */
import styled from 'styled-components';

import { IAttrStyled } from '@/main/types/globalTypes';
import { colors, fonts, multiSelect } from '@theme/index';

import { EInputKind } from '../../Input/Input';
import { ScrollbarStyled } from '../../Scrollbar/ScrollbarStyled';
import { FIXED_LIST_HEIGHT } from '../MultiSelectConstanst';

interface IMultiSelectListPropsStyle {
    left: number;
    top: number;
    width: string;
}
interface IMultiSelectListProps {
    fullWide?: boolean;
    kind: EInputKind;
    hasInputText: boolean;
    style: IMultiSelectListPropsStyle;
}

export const SelectItemContainerStyled = styled.div.attrs(({ className }: IAttrStyled) => ({
    className: `multiselect-item__container ${className || ''}`,
}))<{ name: string } & IAttrStyled>``;

export const MultiSelectDropDownStyled = styled.div<IMultiSelectListProps>`
    max-width: ${(props) => (props.fullWide ? 'none' : '440px')};
    box-sizing: border-box;
    box-shadow: 0 2px 12px 0 rgba(51, 51, 51, 0.2);
    background-color: ${multiSelect.bgColor};
    position: fixed;
    top: calc(100%);
    z-index: 501;

    & .multiselect-item__label {
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    & .multiselect__select-list {
        margin: 0;
        padding: 7px 0;
        border-top: 1px solid;
        border-bottom: 1px solid;
        border-color: ${colors.borderColorDisabled};
        height: ${FIXED_LIST_HEIGHT}px;
        box-sizing: border-box;
        overflow: auto;
        list-style: none;
        ${ScrollbarStyled};

        &::-webkit-scrollbar {
            width: 8px;
        }
    }
    & .select__select-list {
        ${ScrollbarStyled};

        &::-webkit-scrollbar {
            width: 8px;
        }
    }
    & .multiselect-item {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        padding: 6px 32px 6px 22px;
    }
    & .multiselect__search-input.input__container {
        margin: 16px 16px 7px;
        width: auto;
        height: 32px;
        & .input__input-block {
            padding: 0 35px 0 12px;
        }
    }

    & .multiselect-item__container.first-unchecked {
        border-top: 1px solid #d8d8d8;
        &:not(.infinite) {
            padding-top: 6.9px;
            margin-top: 7.1px;
            height: 40px;
        }
        box-sizing: border-box;
    }

    & .multiselect-item__label_highlight {
        font-weight: 600;
        background: transparent;
    }
`;

export const MultiSelectContainerStyled = styled.div.attrs({ 'data-multiselect': 'multiselect' })`
    display: flex;
    position: relative;
    & .multiselect__select-input {
        display: none;
    }
`;

export const MultiSelectButtonsContainer = styled.div.attrs({
    className: 'multiselect__button-block',
})`
    padding: 15px 16px 16px;
    display: flex;
    min-width: 180px;
    justify-content: space-between;
    & button {
        min-height: 32px;
    }
    & .link {
        width: auto;
        display: block;
        height: 32px;
        line-height: 32px;
    }
`;

export const NotFindBlockStyled = styled.div.attrs({
    className: 'multi-select__not-find-block',
})`
    width: 100%;
    height: 32px;
    box-sizing: border-box;
    padding: 8px 16px;
    ${fonts.textSmall};
`;
